// extracted by mini-css-extract-plugin
export default {"searchHeading":"SearchHeader_searchHeading__qJ3YD"};